import { Close } from "@mui/icons-material";
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    styled,
} from "@mui/material";
import React from "react";
import { Suspense } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ImageComponent from "../WarehouseOrderCard/ImageComponent";
import moment from "moment/moment";

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& h2": {
        background: theme.palette.primary.main,
        color: "#fff",
        fontWeight: "500",
    },
}));

const DetailsDiv = styled(Box)(({ theme }) => ({
    background: "#fff",
    "& img": {
        height: "50px",
        width: "50px",
        objectFit: "contain",
        borderRadius: "5px",
    },
    "& p": {
        margin: "0",
        marginTop: "10px",
        marginBottom: "0",
    },
    "& small": {
        color: "grey",
        fontSize: "12px",
        lineHeight: "1.4",
    },
}));

const ViewWarehouseOrderHistory = (props) => {
    const [dialogDetails, setDialogDetails] = useState({
        open: true,
    });

    useEffect(() => {
        props.sendViewDetails(dialogDetails);
    }, [dialogDetails]);

    const handleClose = () => {
        setDialogDetails({
            ...dialogDetails,
            open: false,
        });
    };

    return (
        <StyledDialog
            open={dialogDetails.open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                View Query History - {props.viewDetails?.salesid}
                <IconButton onClick={handleClose}>
                    <Close style={{ color: "#fff" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>SN</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Picked Date/Time</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.viewDetails?.picked_history?.map((pick, index) => {
                            let ctr = index + 1; // Initialize ctr as serial number
                            return (
                                <TableRow key={pick.id}>
                                    <TableCell align="left">{ctr}</TableCell>
                                    <TableCell align="left">{moment(pick.pickedDateTime).format("ddd, MMM Do YYYY, h:mm:ss a")}</TableCell>
                                    <TableCell align="left">{pick.description}</TableCell>
                                    <TableCell align="left">{pick.note}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                {/* <Box
                    display={"grid"}
                    gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    gap="10px"
                    mb={1}
                >
                    <div>
                        <h4>Picked Date/Time</h4>
                    </div>
                    <div>
                        <h4>Description</h4>
                    </div>
                    <div>
                        <h4>Notes</h4>
                    </div>

                </Box>
                <DetailsDiv>
                    {props.viewDetails?.picked_history?.map((pick, index) => {
                        return (
                            <Box
                                display={"grid"}
                                gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
                                alignItems={"center"}
                                gap="10px"
                                key={pick.id}
                                mb={1}
                            >

                                <Box textAlign={"center"}>
                                    <p>{pick.pickedDateTime}</p>
                                </Box>
                                <Box textAlign={"center"}>
                                    <p>{pick.description}</p>
                                </Box>
                                <Box textAlign={"right"}>
                                    {pick.note}
                                </Box>
                            </Box>
                        );
                    })}
                </DetailsDiv> */}
            </DialogContent>
        </StyledDialog>
    );
};

export default ViewWarehouseOrderHistory;
